import { render, staticRenderFns } from "./productWarning.vue?vue&type=template&id=1a9eabbe&scoped=true"
import script from "./productWarning.vue?vue&type=script&lang=js"
export * from "./productWarning.vue?vue&type=script&lang=js"
import style0 from "./productWarning.vue?vue&type=style&index=0&id=1a9eabbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9eabbe",
  null
  
)

export default component.exports